/* KEY STUDIO — meubles et finitions de la visite 3D (octobre 2026).
   Habille la maquette d'un bien : sols texturés, peintures, meubles modélisés, ombres de contact,
   reflets doux. Les données viennent du plan (champ « ameublement ») : des sols communs et des
   « jeux » de meubles (l'ameublement actuel, une proposition d'aménagement…) qu'on affiche un à un.
   Toutes les dimensions des données sont en centimètres du plan ; les hauteurs en mètres.
   Un élément : { t: type, x, y: centre sur le plan, r: orientation en degrés (0 = face au sud du plan,
   90 = face à l'est), w, d: largeur et profondeur, h: hauteur, b: hauteur de pose, c: couleur… }. */
(function () {
  "use strict";

  function habiller(o) {
    const { THREE, appart, murs, meubles, BIEN, P, S, HM, renderer, scene, mobile } = o;
    // Coupe des murs (vue « maison de poupée ») : ce qui est accroché au-dessus disparaît,
    // les carrelages et peintures sont recoupés à cette hauteur.
    const COUPE = o.coupe || HM;
    const deco = o.deco || murs;
    const A = BIEN.ameublement;
    if (!A) return null;
    const lin = (c) => new THREE.Color(c).convertSRGBToLinear();
    const cache = {};
    const std = (c, r = 0.8, m = 0, extra) => {
      const cle = [c, r, m, extra ? JSON.stringify(extra) : ""].join("|");
      if (!cache[cle]) cache[cle] = new THREE.MeshStandardMaterial(Object.assign({ color: lin(c), roughness: r, metalness: m }, extra || {}));
      return cache[cle];
    };
    const deg = (a) => (a || 0) * Math.PI / 180;

    // ------------------------------------------------------------ reflets : un petit studio lumineux
    if (renderer && scene && THREE.PMREMGenerator) {
      try {
        const studio = new THREE.Scene();
        studio.add(new THREE.Mesh(new THREE.BoxGeometry(30, 14, 30), new THREE.MeshBasicMaterial({ color: lin(0xb9b2a6), side: THREE.BackSide })));
        const panneau = (w, h, x, y, z, rx, ry, k) => {
          const m = new THREE.Mesh(new THREE.PlaneGeometry(w, h), new THREE.MeshBasicMaterial({ color: new THREE.Color(k, k * 0.97, k * 0.92), side: THREE.DoubleSide }));
          m.position.set(x, y, z); m.rotation.set(rx, ry, 0); studio.add(m);
        };
        panneau(16, 10, 0, 6.9, 0, Math.PI / 2, 0, 3.2);
        panneau(10, 6, -14.9, 2, 2, 0, Math.PI / 2, 2.2);
        panneau(10, 6, 14.9, 2, -3, 0, -Math.PI / 2, 1.4);
        const pm = new THREE.PMREMGenerator(renderer);
        scene.environment = pm.fromScene(studio, 0.04).texture;
        pm.dispose();
      } catch (e) { /* sans reflets, la maquette reste lisible */ }
    }
    renderer.toneMapping = THREE.ACESFilmicToneMapping;
    renderer.toneMappingExposure = 0.92;

    // ------------------------------------------------------------ textures dessinées (aucune image à charger)
    const toile = (w, h, dessin) => {
      const c = document.createElement("canvas"); c.width = w; c.height = h;
      dessin(c.getContext("2d"), w, h);
      const t = new THREE.CanvasTexture(c);
      t.encoding = THREE.sRGBEncoding;
      t.anisotropy = Math.min(8, renderer.capabilities.getMaxAnisotropy ? renderer.capabilities.getMaxAnisotropy() : 4);
      return t;
    };
    const alea = (graine) => { let s = graine || 1; return () => (s = (s * 16807) % 2147483647) / 2147483647; };
    const teinteVar = (hex, k) => { const c = new THREE.Color(hex); const hsl = {}; c.getHSL(hsl); c.setHSL(hsl.h, hsl.s, Math.min(1, Math.max(0, hsl.l + k))); return "#" + c.getHexString(); };

    function texParquet(teinte, graine) {
      const t = toile(1024, 1024, (g, W, H) => {
        const r = alea(graine || 7), lame = H / 8;
        for (let i = 0; i < 8; i++) {
          let x = -r() * 400;
          while (x < W) {
            const l = 380 + r() * 360;
            g.fillStyle = teinteVar(teinte, (r() - 0.5) * 0.09);
            g.fillRect(x, i * lame, l, lame);
            g.globalAlpha = 0.16;
            for (let k = 0; k < 7; k++) {
              g.strokeStyle = teinteVar(teinte, -0.12 - r() * 0.08);
              g.lineWidth = 1 + r() * 2;
              g.beginPath();
              const yy = i * lame + r() * lame;
              g.moveTo(x, yy);
              g.bezierCurveTo(x + l * 0.3, yy + (r() - 0.5) * 18, x + l * 0.6, yy + (r() - 0.5) * 18, x + l, yy + (r() - 0.5) * 10);
              g.stroke();
            }
            g.globalAlpha = 1;
            g.fillStyle = "rgba(40,28,18,0.35)";
            g.fillRect(x, i * lame, 2, lame);
            x += l;
          }
          g.fillStyle = "rgba(40,28,18,0.3)";
          g.fillRect(0, i * lame, W, 2);
        }
      });
      t.wrapS = t.wrapT = THREE.RepeatWrapping;
      return t;
    }
    function texGalets(teinte) {
      const t = toile(512, 512, (g, W, H) => {
        const r = alea(3);
        g.fillStyle = teinteVar(teinte, -0.12); g.fillRect(0, 0, W, H);
        for (let i = 0; i < 520; i++) {
          g.fillStyle = teinteVar(teinte, (r() - 0.4) * 0.16);
          g.beginPath(); g.ellipse(r() * W, r() * H, 6 + r() * 12, 4 + r() * 8, r() * 3, 0, Math.PI * 2); g.fill();
        }
      });
      t.wrapS = t.wrapT = THREE.RepeatWrapping;
      return t;
    }
    function texLames(teinte) { // carrelage effet bois en petites lames (salle d'eau)
      const t = toile(512, 512, (g, W, H) => {
        const r = alea(11), h = H / 16;
        for (let i = 0; i < 16; i++) {
          let x = -r() * 120;
          while (x < W) {
            const l = 60 + r() * 140;
            g.fillStyle = teinteVar(teinte, (r() - 0.5) * 0.22);
            g.fillRect(x, i * h, l, h - 1.5);
            x += l + 1.5;
          }
        }
      });
      t.wrapS = t.wrapT = THREE.RepeatWrapping;
      return t;
    }
    function texMetro(teinte) { // carreaux métro biseautés
      const t = toile(512, 256, (g, W, H) => {
        g.fillStyle = "#d9d4cb"; g.fillRect(0, 0, W, H);
        const lw = W / 4, lh = H / 4;
        for (let i = 0; i < 4; i++) for (let j = -1; j < 5; j++) {
          const x = j * lw + (i % 2 ? lw / 2 : 0), y = i * lh;
          const gr = g.createLinearGradient(x, y, x, y + lh);
          gr.addColorStop(0, teinteVar(teinte, 0.1)); gr.addColorStop(0.5, teinte); gr.addColorStop(1, teinteVar(teinte, -0.06));
          g.fillStyle = gr; g.fillRect(x + 3, y + 3, lw - 6, lh - 6);
        }
      });
      t.wrapS = t.wrapT = THREE.RepeatWrapping;
      return t;
    }
    function texTapis(motif, c1, c2, c3) {
      return toile(512, 384, (g, W, H) => {
        const r = alea(5);
        g.fillStyle = c1; g.fillRect(0, 0, W, H);
        if (motif === "persan") {
          g.strokeStyle = c2; g.lineWidth = 22; g.strokeRect(18, 18, W - 36, H - 36);
          g.strokeStyle = c3; g.lineWidth = 6; g.strokeRect(38, 38, W - 76, H - 76);
          g.fillStyle = c2; g.beginPath(); g.ellipse(W / 2, H / 2, W * 0.2, H * 0.24, 0, 0, Math.PI * 2); g.fill();
          g.fillStyle = c3; g.beginPath(); g.ellipse(W / 2, H / 2, W * 0.1, H * 0.12, 0, 0, Math.PI * 2); g.fill();
          for (let i = 0; i < 260; i++) { g.fillStyle = r() > 0.5 ? c2 : c3; g.globalAlpha = 0.5; g.fillRect(50 + r() * (W - 100), 50 + r() * (H - 100), 3 + r() * 6, 3 + r() * 6); }
          g.globalAlpha = 1;
          g.fillStyle = "#f2ece2"; for (let x = 0; x < W; x += 6) { g.fillRect(x, 0, 2, 8); g.fillRect(x, H - 8, 2, 8); }
        } else { // laine unie, bordure discrète
          for (let i = 0; i < 4000; i++) { g.fillStyle = r() > 0.5 ? teinteVar(c1, 0.04) : teinteVar(c1, -0.04); g.fillRect(r() * W, r() * H, 2, 2); }
          g.strokeStyle = c2; g.lineWidth = 8; g.strokeRect(14, 14, W - 28, H - 28);
        }
      });
    }
    function texTableau(motif) {
      return toile(256, 256, (g, W, H) => {
        const r = alea(motif.length * 13);
        const fond = { jazz: "#e3b52c", affiche: "#f0c94a", marine: "#7f8f99", dessin: "#f4f1ea", abstrait: "#4d6c95", carte: "#e8dcc0", vitrail: "#f6f4ef", lin: "#d9d0c2", olive: "#9aa48a" }[motif] || "#ccc";
        g.fillStyle = fond; g.fillRect(0, 0, W, H);
        if (motif === "jazz") for (let i = 0; i < 40; i++) { g.fillStyle = r() > 0.4 ? "#1d1b19" : "#f4e7c4"; g.fillRect(r() * W, r() * H, 6 + r() * 30, 20 + r() * 60); }
        else if (motif === "affiche") { g.fillStyle = "#c63c2e"; g.beginPath(); g.moveTo(40, 200); g.lineTo(130, 70); g.lineTo(220, 200); g.fill(); g.fillStyle = "#2f5e8c"; g.fillRect(0, 200, W, 56); g.fillStyle = "#1d1b19"; g.fillRect(30, 20, 196, 18); }
        else if (motif === "marine") { g.fillStyle = "#c8d0d4"; g.fillRect(0, 0, W, 110); g.fillStyle = "#596a73"; g.fillRect(0, 150, W, 106); g.fillStyle = "#3f4b51"; g.beginPath(); g.moveTo(150, 150); g.lineTo(256, 60); g.lineTo(256, 160); g.fill(); }
        else if (motif === "dessin") { g.strokeStyle = "#3b3a37"; g.lineWidth = 3; g.beginPath(); g.moveTo(40, 170); g.bezierCurveTo(90, 60, 170, 210, 220, 110); g.stroke(); g.beginPath(); g.ellipse(120, 110, 50, 30, 0.4, 0, 6.3); g.stroke(); }
        else if (motif === "abstrait") for (let i = 0; i < 14; i++) { g.fillStyle = ["#9fb7d4", "#2c3f5e", "#e7e2d5", "#7d93b0"][i % 4]; g.fillRect(r() * W, r() * H, 20 + r() * 80, 10 + r() * 90); }
        else if (motif === "carte") { g.strokeStyle = "#b89a6a"; for (let x = 0; x < W; x += 21) for (let y = 0; y < H; y += 26) { g.strokeRect(x + 2, y + 2, 17, 22); g.fillStyle = ["#9bc1b9", "#e3c370", "#d39a8a"][(x + y) % 3]; g.fillRect(x + 6, y + 8, 9, 10); } }
        else if (motif === "olive") { g.strokeStyle = "#5e6b4e"; g.lineWidth = 4; for (let i = 0; i < 9; i++) { g.beginPath(); g.ellipse(60 + r() * 140, 40 + r() * 180, 30, 9, r() * 3, 0, 6.3); g.stroke(); } }
        else if (motif === "lin") { g.fillStyle = "#b9a98f"; g.beginPath(); g.arc(W * 0.55, H * 0.45, 70, 0, 6.3); g.fill(); g.fillStyle = "#8a8f7a"; g.fillRect(40, 170, 120, 50); }
      });
    }
    function texLivres() {
      return toile(256, 64, (g, W, H) => {
        const r = alea(9); let x = 0;
        const c = ["#7b2e2a", "#2d4a6b", "#d8cfbf", "#c9a24a", "#3c5a45", "#1f1f1f", "#e9e4da", "#8c6a4a"];
        while (x < W) { const w = 5 + r() * 10; g.fillStyle = c[Math.floor(r() * c.length)]; g.fillRect(x, H * (0.1 + r() * 0.2), w - 1, H); x += w; }
      });
    }
    const ombreTex = toile(128, 128, (g) => {
      const gr = g.createRadialGradient(64, 64, 6, 64, 64, 64);
      gr.addColorStop(0, "rgba(0,0,0,0.55)"); gr.addColorStop(0.55, "rgba(0,0,0,0.22)"); gr.addColorStop(1, "rgba(0,0,0,0)");
      g.fillStyle = gr; g.fillRect(0, 0, 128, 128);
    });
    ombreTex.encoding = THREE.LinearEncoding;
    const ombreMat = new THREE.MeshBasicMaterial({ map: ombreTex, transparent: true, depthWrite: false, opacity: 0.55 });

    // ------------------------------------------------------------ outils de modelage (mètres, origine au sol, face vers +z)
    function boite(g, w, h, d, x, y, z, m, ombre = true) {
      const mesh = new THREE.Mesh(new THREE.BoxGeometry(w, h, d), m);
      mesh.position.set(x, y + h / 2, z); mesh.castShadow = ombre; mesh.receiveShadow = true; g.add(mesh); return mesh;
    }
    function coussin(g, w, h, d, x, y, z, m, rr) { // boîte aux arêtes arrondies
      const r = Math.min(rr || 0.05, w / 2.2, h / 2.2), b = Math.min(r, d / 2.4);
      const s = new THREE.Shape(), x0 = -w / 2, y0 = -h / 2;
      s.moveTo(x0 + r, y0); s.lineTo(x0 + w - r, y0); s.quadraticCurveTo(x0 + w, y0, x0 + w, y0 + r);
      s.lineTo(x0 + w, y0 + h - r); s.quadraticCurveTo(x0 + w, y0 + h, x0 + w - r, y0 + h);
      s.lineTo(x0 + r, y0 + h); s.quadraticCurveTo(x0, y0 + h, x0, y0 + h - r); s.lineTo(x0, y0 + r); s.quadraticCurveTo(x0, y0, x0 + r, y0);
      const geo = new THREE.ExtrudeGeometry(s, { depth: Math.max(0.002, d - 2 * b), bevelEnabled: true, bevelThickness: b, bevelSize: b * 0.9, bevelSegments: mobile ? 2 : 4, curveSegments: mobile ? 4 : 7 });
      geo.translate(0, 0, -(d - 2 * b) / 2);
      const mesh = new THREE.Mesh(geo, m);
      mesh.position.set(x, y + h / 2, z); mesh.castShadow = true; mesh.receiveShadow = true; g.add(mesh); return mesh;
    }
    function cyl(g, r1, r2, h, x, y, z, m, seg = 20) {
      const mesh = new THREE.Mesh(new THREE.CylinderGeometry(r1, r2, h, seg), m);
      mesh.position.set(x, y + h / 2, z); mesh.castShadow = true; mesh.receiveShadow = true; g.add(mesh); return mesh;
    }
    function sphere(g, r, x, y, z, m, sx = 1, sy = 1, sz = 1) {
      const mesh = new THREE.Mesh(new THREE.SphereGeometry(r, 18, 14), m);
      mesh.position.set(x, y, z); mesh.scale.set(sx, sy, sz); mesh.castShadow = true; g.add(mesh); return mesh;
    }
    function pieds(g, w, d, h, m, rr = 0.018, retrait = 0.04, fuselés = false) {
      [[-1, -1], [1, -1], [-1, 1], [1, 1]].forEach(([i, j]) => cyl(g, rr, fuselés ? rr * 0.6 : rr, h, i * (w / 2 - retrait), 0, j * (d / 2 - retrait), m, 10));
    }
    function poignee(g, x, y, z, m, horiz = true, l = 0.1) { boite(g, horiz ? l : 0.012, horiz ? 0.012 : l, 0.02, x, y, z, m, false); }

    const MAT = {
      laiton: std("#c9a14a", 0.35, 0.9), chrome: std("#d8dadc", 0.2, 1), noirMat: std("#1c1c1c", 0.5, 0.2),
      blanc: std("#f4f2ee", 0.6), blancLaque: std("#f6f5f2", 0.3), draps: std("#f7f5f1", 0.92),
      verre: new THREE.MeshPhysicalMaterial({ color: lin("#dfe9ea"), roughness: 0.05, metalness: 0, transparent: true, opacity: 0.25, depthWrite: false }),
      miroir: std("#c9c2b4", 0.06, 1), miroirBronze: std("#8a7356", 0.08, 1),
      ecran: std("#0d0e10", 0.25, 0.4), abat: new THREE.MeshStandardMaterial({ color: lin("#f6ead2"), roughness: 0.9, emissive: lin("#ffd9a0"), emissiveIntensity: 0.55 }),
      terre: std("#b9714a", 0.85), ceramique: std("#efe9e0", 0.4), feuillage: std("#5f7a4c", 0.85), feuillage2: std("#7d9466", 0.85),
    };

    // ------------------------------------------------------------ catalogue
    const T = {};
    // Séjour
    T.canape = (g, e) => { // canapé en cuir (ou tissu), dossier et accoudoirs
      const w = e.w / 100, d = e.d / 100, c = std(e.c || "#3f4c5f", e.tissu ? 0.95 : 0.42, 0, e.tissu ? null : { envMapIntensity: 0.8 });
      const bras = 0.18, hs = 0.42;
      coussin(g, w, 0.2, d, 0, 0.08, 0, c, 0.04);
      coussin(g, w - 0.04, 0.42, 0.2, 0, 0.26, -d / 2 + 0.11, c, 0.08);
      coussin(g, bras, 0.38, d, -w / 2 + bras / 2, 0.08, 0, c, 0.07);
      coussin(g, bras, 0.38, d, w / 2 - bras / 2, 0.08, 0, c, 0.07);
      const n = e.places || 2, lw = (w - 2 * bras) / n;
      for (let i = 0; i < n; i++) coussin(g, lw - 0.01, 0.14, d - 0.24, -w / 2 + bras + lw * (i + 0.5), 0.27, 0.08, c, 0.05);
      if (e.tissu) for (let i = 0; i < n; i++) coussin(g, lw - 0.04, 0.4, 0.14, -w / 2 + bras + lw * (i + 0.5), 0.36, -d / 2 + 0.26, c, 0.07);
      if (e.pieds) pieds(g, w - 0.1, d - 0.1, 0.08, std(e.pieds, 0.6)); else boite(g, w - 0.06, 0.08, d - 0.08, 0, 0, 0, MAT.noirMat);
      if (e.plaid) coussin(g, 0.5, 0.03, d - 0.1, w / 2 - bras - 0.3, hs - 0.01, 0.02, std(e.plaid, 0.95), 0.015);
      if (e.coussins) e.coussins.forEach((cc, i) => coussin(g, 0.4, 0.4, 0.12, -w / 2 + bras + 0.25 + i * ((w - 2 * bras - 0.5) / Math.max(1, e.coussins.length - 1)), 0.4, -d / 2 + 0.3, std(cc, 0.95), 0.08).rotation.x = -0.25);
    };
    T.fauteuilClub = (g, e) => {
      const c = std(e.c || "#b06d2c", 0.38, 0, { envMapIntensity: 0.9 });
      coussin(g, 0.78, 0.36, 0.8, 0, 0.06, 0, c, 0.1);
      coussin(g, 0.78, 0.4, 0.22, 0, 0.36, -0.29, c, 0.1);
      coussin(g, 0.17, 0.3, 0.72, -0.31, 0.36, 0.02, c, 0.08); coussin(g, 0.17, 0.3, 0.72, 0.31, 0.36, 0.02, c, 0.08);
      coussin(g, 0.46, 0.1, 0.5, 0, 0.42, 0.08, c, 0.04);
      boite(g, 0.7, 0.06, 0.7, 0, 0, 0, std("#3b2416", 0.6));
    };
    T.fauteuilBoucle = (g, e) => { // fauteuil moderne arrondi, piètement chêne
      const c = std(e.c || "#ece5d8", 0.98);
      coussin(g, 0.78, 0.2, 0.78, 0, 0.18, 0, c, 0.1);
      coussin(g, 0.78, 0.44, 0.26, 0, 0.32, -0.26, c, 0.13);
      coussin(g, 0.18, 0.28, 0.6, -0.31, 0.32, 0.02, c, 0.09); coussin(g, 0.18, 0.28, 0.6, 0.31, 0.32, 0.02, c, 0.09);
      pieds(g, 0.66, 0.66, 0.18, std(e.pieds || "#c9a77c", 0.55), 0.02, 0.04, true);
    };
    T.tableBasse = (g, e) => {
      const w = e.w / 100, d = e.d / 100, bois = std(e.c || "#a29b90", 0.7);
      if (e.ronde) { cyl(g, w / 2, w / 2, 0.04, 0, (e.h || 0.4) - 0.04, 0, bois, 40); cyl(g, w * 0.32, w * 0.36, (e.h || 0.4) - 0.04, 0, 0, 0, bois, 32); return; }
      boite(g, w, 0.05, d, 0, (e.h || 0.45) - 0.05, 0, bois);
      boite(g, w - 0.04, 0.03, d - 0.04, 0, 0.1, 0, bois);
      [[-1], [1]].forEach(([i]) => { boite(g, 0.05, (e.h || 0.45) - 0.05, d - 0.02, i * (w / 2 - 0.025), 0, 0, bois); });
      if (e.objets !== false) { boite(g, 0.24, 0.03, 0.17, -w * 0.2, (e.h || 0.45), 0, std("#2f5b8c", 0.8)); boite(g, 0.14, 0.09, 0.1, w * 0.25, (e.h || 0.45), -0.05, std("#9cc2e0", 0.7)); }
    };
    T.tapis = (g, e) => {
      const mesh = new THREE.Mesh(new THREE.PlaneGeometry(e.w / 100, e.d / 100), new THREE.MeshStandardMaterial({ map: texTapis(e.motif || "persan", e.c || "#a64b39", e.c2 || "#2c3d5c", e.c3 || "#e8d9b8"), roughness: 1 }));
      mesh.rotation.x = -Math.PI / 2; mesh.position.y = 0.006; mesh.receiveShadow = true; g.add(mesh);
    };
    T.buffet = (g, e) => { // buffet ou bahut en bois, portes et tiroirs
      const w = e.w / 100, d = e.d / 100, h = e.h || 0.85, bois = std(e.c || "#8a4a24", 0.45, 0, { envMapIntensity: 0.7 });
      const p = e.pied || 0.1;
      boite(g, w, h - p, d, 0, p, 0, bois);
      boite(g, w + 0.03, 0.03, d + 0.03, 0, h - 0.03, 0, std(e.dessus || e.c || "#7a3f1e", 0.35));
      pieds(g, w - 0.04, d - 0.04, p, bois, 0.03, 0.03, !!e.moderne);
      const portes = e.portes || 2, fond = std(teinteVar(e.c || "#8a4a24", -0.05), 0.5);
      for (let i = 0; i < portes; i++) {
        const lw = (w - 0.06) / portes;
        boite(g, lw - 0.02, h - p - 0.22, 0.015, -w / 2 + 0.03 + lw * (i + 0.5), p + 0.04, d / 2, fond, false);
        if (!e.moderne) poignee(g, -w / 2 + 0.03 + lw * (i + 0.5) + (i % 2 ? -1 : 1) * (lw / 2 - 0.06), p + (h - p) * 0.45, d / 2 + 0.015, MAT.laiton, false, 0.07);
      }
      if (!e.moderne) for (let i = 0; i < portes; i++) poignee(g, -w / 2 + 0.03 + ((w - 0.06) / portes) * (i + 0.5), h - 0.11, d / 2 + 0.01, MAT.laiton);
    };
    T.tele = (g, e) => {
      const w = (e.w || 100) / 100, b = e.b || 0;
      boite(g, w, w * 0.57, 0.04, 0, b + 0.07, 0, MAT.ecran);
      boite(g, 0.25, 0.02, 0.18, 0, b, 0, MAT.noirMat);
      boite(g, 0.04, 0.06, 0.03, 0, b + 0.01, 0, MAT.noirMat);
      if (e.box) boite(g, 0.2, 0.05, 0.16, w * 0.38, b, 0.04, MAT.noirMat);
    };
    T.statue = (g, e) => { // grande statuette africaine en bois peint
      const h = e.h || 1.85, c = std(e.c || "#9e2b22", 0.6), bois = std("#c9b089", 0.7);
      cyl(g, 0.05, 0.045, h * 0.42, -0.035, 0.03, 0, bois, 10); cyl(g, 0.05, 0.045, h * 0.42, 0.035, 0.03, 0, bois, 10);
      coussin(g, 0.2, h * 0.33, 0.12, 0, h * 0.44, 0, c, 0.04);
      cyl(g, 0.03, 0.035, 0.06, 0, h * 0.77, 0, std("#4a2e1d", 0.6), 10);
      sphere(g, 0.065, 0, h * 0.86, 0, std("#4a2e1d", 0.5), 1, 1.2, 1);
      cyl(g, 0.11, 0.11, 0.015, 0, h * 0.93, 0, std("#e9e1cf", 0.8), 18); cyl(g, 0.06, 0.07, 0.07, 0, h * 0.94, 0, std("#e9e1cf", 0.8), 14);
      cyl(g, 0.11, 0.12, 0.03, 0, 0, 0, std("#3a2a1e", 0.7), 16);
    };
    T.armoireChinoise = (g, e) => {
      const w = e.w / 100, d = e.d / 100, h = e.h || 1.75, laque = std(e.c || "#a8261d", 0.28, 0, { envMapIntensity: 1 });
      boite(g, w, h - 0.08, d, 0, 0.08, 0, laque);
      pieds(g, w - 0.04, d - 0.04, 0.08, std("#5d140f", 0.5), 0.025);
      boite(g, w + 0.04, 0.04, d + 0.04, 0, h - 0.04, 0, laque);
      boite(g, 0.004, h - 0.4, 0.012, 0, 0.3, d / 2 + 0.002, std("#5d140f", 0.6), false);
      const m = new THREE.Mesh(new THREE.CylinderGeometry(0.075, 0.075, 0.01, 32), MAT.laiton); m.rotation.x = Math.PI / 2; m.position.set(0, h * 0.62, d / 2 + 0.008); g.add(m);
      if (e.objets !== false) { [-0.25, -0.08, 0.1, 0.27].forEach((x, i) => sphere(g, 0.06 + (i % 2) * 0.02, x * w * 1.6, h + 0.07, 0, std(["#c69a5b", "#8c6b48", "#e1c79b", "#6f5133"][i], 0.4, 0.2), 1, 0.55, 1)); }
    };
    T.console = (g, e) => {
      const w = e.w / 100, d = e.d / 100, h = e.h || 0.8, bois = std(e.c || "#9c5a2c", 0.45);
      boite(g, w, 0.04, d, 0, h - 0.04, 0, bois);
      boite(g, w - 0.06, 0.1, d - 0.04, 0, h - 0.14, 0, bois);
      pieds(g, w - 0.02, d - 0.02, h - 0.04, bois, 0.022, 0.025, !e.moderne);
      if (!e.moderne) boite(g, w - 0.1, 0.02, d - 0.06, 0, 0.12, 0, bois);
      (e.objets || ["statuette", "statuette", "cadre"]).forEach((k, i, arr) => {
        const x = -w / 2 + 0.15 + i * ((w - 0.3) / Math.max(1, arr.length - 1));
        if (k === "statuette") { cyl(g, 0.04, 0.05, 0.03, x, h, 0, std("#2b2a28", 0.4, 0.5)); cyl(g, 0.012, 0.02, 0.3, x, h + 0.03, 0, std("#b28a3c", 0.3, 0.9)); sphere(g, 0.025, x, h + 0.35, 0, std("#b28a3c", 0.3, 0.9)); }
        else if (k === "vase") { cyl(g, 0.06, 0.08, 0.28, x, h, 0, MAT.ceramique, 20); [0, 1, 2].forEach((j) => sphere(g, 0.05, x + (j - 1) * 0.04, h + 0.36, 0, MAT.feuillage2, 1, 1.8, 1)); }
        else if (k === "lampe") { cyl(g, 0.07, 0.09, 0.28, x, h, 0, MAT.ceramique, 20); cyl(g, 0.11, 0.14, 0.16, x, h + 0.28, 0, MAT.abat, 24); }
        else boite(g, 0.16, 0.2, 0.02, x, h, -0.04, std("#d64a35", 0.7)).rotation.x = -0.18;
      });
    };
    T.tabouret = (g, e) => {
      const bois = std(e.c || "#4b2d1a", 0.6);
      cyl(g, 0.17, 0.17, 0.05, 0, 0.62, 0, bois, 24);
      [0, 1, 2].forEach((i) => { const a = (i / 3) * Math.PI * 2, m = cyl(g, 0.025, 0.03, 0.66, Math.cos(a) * 0.12, 0, Math.sin(a) * 0.12, bois, 8); m.rotation.z = Math.cos(a) * 0.12; m.rotation.x = -Math.sin(a) * 0.12; });
      if (e.sculpture !== false) { sphere(g, 0.09, 0, 0.74, 0.02, std("#c4855c", 0.8), 1.2, 0.8, 0.9); sphere(g, 0.045, 0.05, 0.86, -0.04, std("#c4855c", 0.8)); }
    };
    T.chien = (g) => { // chien sculpté (braque), près de l'armoire
      const c = std("#5a514c", 0.5, 0.3);
      sphere(g, 0.16, 0, 0.42, 0, c, 1.8, 0.8, 0.8); sphere(g, 0.08, 0.27, 0.62, 0, c, 1.4, 1, 0.9);
      [-0.15, 0.12].forEach((x) => [-0.05, 0.05].forEach((z) => cyl(g, 0.02, 0.018, 0.38, x, 0, z, c, 8)));
    };
    T.lampadaire = (g, e) => {
      const m = std(e.c || "#2a2a2a", 0.4, 0.6);
      cyl(g, 0.14, 0.15, 0.03, 0, 0, 0, m, 24); cyl(g, 0.012, 0.012, 1.45, 0, 0.03, 0, m, 8);
      cyl(g, e.arc ? 0.2 : 0.14, e.arc ? 0.24 : 0.17, 0.24, 0, 1.45, 0, MAT.abat, 28);
    };
    T.lampeBureau = (g, e) => {
      const m = std("#1f1f1f", 0.4, 0.5), b = e.b || 0;
      cyl(g, 0.08, 0.09, 0.02, 0, b, 0, m); const bras = cyl(g, 0.01, 0.01, 0.42, 0.04, b + 0.02, 0, m, 6); bras.rotation.z = -0.35;
      sphere(g, 0.08, 0.17, b + 0.44, 0, m, 1, 0.7, 1);
    };
    T.plante = (g, e) => { // grande plante en pot (olivier, ficus)
      const h = e.h || 1.6, pot = std(e.pot || "#b86f48", 0.85);
      cyl(g, 0.2, 0.16, 0.38, 0, 0, 0, pot, 24);
      cyl(g, 0.025, 0.035, h * 0.55, 0, 0.36, 0, std("#6e5843", 0.9), 8);
      const r = alea(Math.round((e.x || 3) * 7));
      for (let i = 0; i < 14; i++) sphere(g, 0.13 + r() * 0.08, (r() - 0.5) * 0.55, 0.36 + h * 0.5 + r() * h * 0.45, (r() - 0.5) * 0.55, i % 2 ? MAT.feuillage : MAT.feuillage2, 1, 0.8, 1);
    };
    T.plantePetite = (g, e) => { const b = e.b || 0; cyl(g, 0.08, 0.065, 0.16, 0, b, 0, MAT.ceramique); [0, 1, 2, 3].forEach((i) => sphere(g, 0.06, (i % 2 - 0.5) * 0.06, b + 0.22 + i * 0.03, ((i >> 1) - 0.5) * 0.06, MAT.feuillage2)); };
    // Salle à manger
    T.tableRepas = (g, e) => {
      const w = e.w / 100, d = e.d / 100, h = 0.76, bois = std(e.c || "#6b3a1f", 0.42, 0, { envMapIntensity: 0.6 });
      if (e.ronde) { cyl(g, w / 2, w / 2, 0.04, 0, h - 0.04, 0, bois, 48); cyl(g, 0.06, 0.08, h - 0.04, 0, 0, 0, bois, 20); cyl(g, 0.3, 0.32, 0.04, 0, 0, 0, bois, 32); return; }
      boite(g, w, 0.04, d, 0, h - 0.04, 0, bois);
      if (e.cuir) boite(g, w - 0.12, 0.004, d - 0.12, 0, h, 0, std(e.cuir, 0.6), false);
      boite(g, w - 0.08, 0.1, d - 0.08, 0, h - 0.14, 0, bois);
      pieds(g, w - 0.04, d - 0.04, h - 0.04, bois, 0.03, 0.03, true);
    };
    T.chaise = (g, e) => {
      const bois = std(e.c || "#4a2716", 0.45), assise = std(e.assise || "#2b2c2e", 0.8);
      if (e.moderne) { // chaise scandinave
        boite(g, 0.44, 0.05, 0.44, 0, 0.42, 0, std(e.assise || "#d8cbb4", 0.95));
        pieds(g, 0.4, 0.4, 0.42, bois, 0.017, 0.03, true);
        const dos = coussin(g, 0.42, 0.12, 0.03, 0, 0.66, -0.2, bois, 0.04); dos.rotation.x = -0.12;
        boite(g, 0.02, 0.25, 0.02, -0.18, 0.45, -0.2, bois); boite(g, 0.02, 0.25, 0.02, 0.18, 0.45, -0.2, bois);
        return;
      }
      boite(g, 0.44, 0.05, 0.42, 0, 0.42, 0, bois); boite(g, 0.4, 0.035, 0.38, 0, 0.47, 0.01, assise);
      pieds(g, 0.4, 0.38, 0.42, bois, 0.018, 0.025, true);
      boite(g, 0.03, 0.5, 0.03, -0.19, 0.45, -0.19, bois); boite(g, 0.03, 0.5, 0.03, 0.19, 0.45, -0.19, bois);
      boite(g, 0.42, 0.05, 0.03, 0, 0.9, -0.19, bois);
      const x1 = boite(g, 0.5, 0.03, 0.02, 0, 0.66, -0.19, bois); x1.rotation.z = 0.78; const x2 = boite(g, 0.5, 0.03, 0.02, 0, 0.66, -0.19, bois); x2.rotation.z = -0.78;
    };
    T.suspension = (g, e) => {
      const z = e.z || 1.75;
      cyl(g, 0.004, 0.004, HM - z - 0.2, 0, z + 0.2, 0, MAT.noirMat, 4);
      if (e.rotin) { const m = sphere(g, 0.24, 0, z + 0.14, 0, std("#c49a63", 0.95), 1, 0.7, 1); m.castShadow = false; return; }
      const cl = new THREE.Mesh(new THREE.CylinderGeometry(0.05, 0.22, 0.2, 28, 1, true), std(e.c || "#8f9294", 0.35, 0.8, { side: THREE.DoubleSide }));
      cl.position.set(0, z + 0.1, 0); g.add(cl);
      sphere(g, 0.06, 0, z + 0.03, 0, MAT.abat);
    };
    // Chambre
    T.lit = (g, e) => {
      const w = e.w / 100, d = e.d / 100, m = std(e.c || "#3c5574", 0.45, 0.6);
      const metal = !e.tete;
      coussin(g, w - 0.04, 0.24, d - 0.06, 0, 0.18, 0.02, MAT.draps, 0.06);
      coussin(g, w + 0.02, 0.1, d - 0.4, 0, 0.4, 0.17, std(e.couette || "#f8f6f2", 0.95), 0.05);
      [-0.27, 0.27].forEach((x) => coussin(g, w * 0.4, 0.13, 0.4, x * w * 1.5, 0.4, -d / 2 + 0.26, MAT.draps, 0.06));
      if (e.plaid) coussin(g, w + 0.04, 0.03, 0.5, 0, 0.5, d / 2 - 0.35, std(e.plaid, 0.95), 0.015);
      if (metal) {
        [[-1, -1], [1, -1]].forEach(([i, j]) => { cyl(g, 0.02, 0.02, 1.05, i * w / 2, 0, j * d / 2, m, 10); sphere(g, 0.035, i * w / 2, 1.08, j * d / 2, m); });
        [[-1, 1], [1, 1]].forEach(([i, j]) => { cyl(g, 0.02, 0.02, 0.72, i * w / 2, 0, j * d / 2, m, 10); sphere(g, 0.035, i * w / 2, 0.75, j * d / 2, m); });
        [0.38, 0.98].forEach((y) => boite(g, w, 0.02, 0.02, 0, y, -d / 2, m));
        [0.38, 0.68].forEach((y) => boite(g, w, 0.02, 0.02, 0, y, d / 2, m));
        for (let i = 1; i < 6; i++) boite(g, 0.012, 0.3, 0.012, -w / 2 + (w / 6) * i, 0.38, d / 2, m);
        boite(g, w, 0.04, 0.04, 0, 0.16, -d / 2, m); boite(g, w, 0.04, 0.04, 0, 0.16, d / 2, m);
      } else {
        boite(g, w + 0.06, 0.2, d + 0.04, 0, 0.06, 0, std(e.c || "#c9a77c", 0.55));
        coussin(g, w + 0.12, 0.95, 0.1, 0, 0.2, -d / 2 - 0.03, std(e.tete, 0.95), 0.05);
      }
    };
    T.chevet = (g, e) => {
      const w = (e.w || 45) / 100, d = (e.d || 35) / 100, h = e.h || 0.62, bois = std(e.c || "#6e3d22", 0.45);
      boite(g, w, h - 0.08, d, 0, 0.08, 0, bois); pieds(g, w - 0.03, d - 0.03, 0.08, bois, 0.018, 0.02, true);
      if (e.marbre) boite(g, w + 0.02, 0.02, d + 0.02, 0, h, 0, std(e.marbre, 0.25));
      for (let i = 0; i < (e.tiroirs || 3); i++) { boite(g, w - 0.04, (h - 0.14) / (e.tiroirs || 3) - 0.02, 0.01, 0, 0.1 + i * ((h - 0.14) / (e.tiroirs || 3)), d / 2, std(teinteVar(e.c || "#6e3d22", 0.04), 0.45), false); poignee(g, 0, 0.1 + (i + 0.5) * ((h - 0.14) / (e.tiroirs || 3)), d / 2 + 0.012, MAT.laiton, true, 0.05); }
      if (e.lampe === "liseuse") T.lampeBureau(g, { b: h + (e.marbre ? 0.02 : 0) });
      else if (e.lampe) { cyl(g, 0.06, 0.08, 0.22, 0, h, 0, std(e.lampe, 0.5), 20); cyl(g, 0.1, 0.13, 0.15, 0, h + 0.22, 0, MAT.abat, 24); }
    };
    T.voilages = (g, e) => { // baldaquin : tringle en cadre et voilages blancs aux angles
      const w = e.w / 100, d = e.d / 100, z = e.z || 2.3, tr = std("#e9e7e2", 0.4, 0.3);
      boite(g, w, 0.025, 0.025, 0, z, -d / 2, tr); boite(g, w, 0.025, 0.025, 0, z, d / 2, tr);
      boite(g, 0.025, 0.025, d, -w / 2, z, 0, tr); boite(g, 0.025, 0.025, d, w / 2, z, 0, tr);
      const voile = new THREE.MeshStandardMaterial({ color: lin("#fbfaf7"), roughness: 1, transparent: true, opacity: 0.86, side: THREE.DoubleSide });
      [[-1, -1], [1, -1], [-1, 1], [1, 1]].forEach(([i, j]) => {
        for (let k = 0; k < 4; k++) {
          const p = new THREE.Mesh(new THREE.CylinderGeometry(0.045, 0.06, z - 0.02, 10, 1, true), voile);
          p.position.set(i * (w / 2 - 0.08 - (k % 2) * 0.07), (z - 0.02) / 2, j * (d / 2 - 0.05 - (k >> 1) * 0.05)); p.castShadow = true; g.add(p);
        }
      });
    };
    T.bibliotheque = (g, e) => {
      const w = e.w / 100, d = e.d / 100, h = e.h || 2, bois = std(e.c || "#d9c7a5", 0.65);
      boite(g, w, h, 0.02, 0, 0, -d / 2 + 0.01, bois);
      boite(g, 0.02, h, d, -w / 2 + 0.01, 0, 0, bois); boite(g, 0.02, h, d, w / 2 - 0.01, 0, 0, bois);
      const n = e.etageres || 6, livres = new THREE.MeshStandardMaterial({ map: texLivres(), roughness: 0.9 });
      for (let i = 0; i <= n; i++) {
        boite(g, w, 0.02, d, 0, (h - 0.02) * (i / n), 0, bois);
        if (i < n && (e.plein !== false || i % 2 === 0)) boite(g, w - 0.06, (h / n) * 0.68, d * 0.75, 0, (h - 0.02) * (i / n) + 0.02, 0.01, livres);
      }
    };
    T.secretaire = (g, e) => { // secrétaire Louis-Philippe en acajou
      const w = (e.w || 95) / 100, d = (e.d || 45) / 100, h = e.h || 1.45, bois = std(e.c || "#5a2814", 0.32, 0, { envMapIntensity: 0.8 });
      boite(g, w, h - 0.06, d, 0, 0.06, 0, bois);
      boite(g, w + 0.03, 0.03, d + 0.03, 0, h, 0, std(e.marbre || "#2a2622", 0.2));
      boite(g, w + 0.02, 0.05, d + 0.02, 0, 0, 0, bois);
      boite(g, w - 0.08, h * 0.38, 0.012, 0, h * 0.42, d / 2, std(teinteVar(e.c || "#5a2814", 0.06), 0.3), false);
      for (let i = 0; i < 3; i++) { boite(g, w - 0.06, 0.13, 0.012, 0, 0.1 + i * 0.15, d / 2, std(teinteVar(e.c || "#5a2814", 0.03), 0.3), false); [-0.22, 0.22].forEach((x) => sphere(g, 0.014, x * w * 1.5, 0.165 + i * 0.15, d / 2 + 0.015, MAT.laiton)); }
      if (e.objets !== false) { cyl(g, 0.05, 0.06, 0.18, -w * 0.3, h + 0.03, 0, std("#c47f3e", 0.5)); sphere(g, 0.07, w * 0.32, h + 0.13, 0, std("#4f7a3c", 0.6), 0.8, 1.4, 0.8); boite(g, 0.32, 0.42, 0.02, 0, h + 0.03, -0.06, std("#3d5f94", 0.7)); }
    };
    T.armoireGlace = (g, e) => { // placard coulissant à portes miroir (bronze)
      const w = e.w / 100, d = e.d / 100, h = e.h || 2.45;
      boite(g, w, h, d, 0, 0, 0, MAT.blanc);
      boite(g, w / 2 - 0.01, h - 0.06, 0.01, -w / 4, 0.03, d / 2 + 0.005, e.blanc ? MAT.blancLaque : MAT.miroirBronze, false);
      boite(g, w / 2 - 0.01, h - 0.06, 0.01, w / 4, 0.03, d / 2 + 0.018, e.blanc ? MAT.blancLaque : MAT.miroirBronze, false);
      boite(g, w, 0.02, 0.03, 0, h - 0.02, d / 2 + 0.01, MAT.chrome, false);
    };
    T.etagereOuverte = (g, e) => { // étagère en pin, casiers et imprimante
      const w = e.w / 100, d = e.d / 100, h = e.h || 2.1, pin = std("#e7cfa1", 0.7);
      boite(g, 0.02, h, d, -w / 2, 0, 0, pin); boite(g, 0.02, h, d, w / 2, 0, 0, pin);
      [0.05, 0.45, 0.8, 1.2, 1.6, 2.0].forEach((y) => boite(g, w, 0.02, d, 0, y, 0, pin));
      boite(g, w - 0.08, 0.3, d - 0.05, 0, 0.47, 0, MAT.blanc); boite(g, w - 0.1, 0.2, d - 0.06, 0, 0.83, 0, MAT.noirMat);
      boite(g, w - 0.08, 0.3, d - 0.05, 0, 1.23, 0, MAT.blanc);
      boite(g, w - 0.08, 0.28, d * 0.75, 0, 1.62, 0, new THREE.MeshStandardMaterial({ map: texLivres(), roughness: 0.9 }));
    };
    // Pièce modulable
    T.banquette = (g, e) => { // lit banquette gigogne
      const w = e.w / 100, d = e.d / 100, c = std(e.c || "#7c736b", 0.75);
      coussin(g, w, 0.32, d, 0, 0.02, 0, c, 0.03);
      coussin(g, w, 0.12, d - 0.04, 0, 0.34, 0.01, std(teinteVar(e.c || "#7c736b", 0.04), 0.8), 0.04);
      coussin(g, w, 0.32, 0.06, 0, 0.36, -d / 2 + 0.03, c, 0.03);
      coussin(g, 0.06, 0.24, d, -w / 2 + 0.03, 0.36, 0, c, 0.03); coussin(g, 0.06, 0.24, d, w / 2 - 0.03, 0.36, 0, c, 0.03);
      (e.coussins || ["#e9dfcf", "#c53b3b", "#e9dfcf", "#c53b3b"]).forEach((cc, i, a) => { const k = coussin(g, 0.42, 0.4, 0.12, -w / 2 + 0.35 + i * ((w - 0.7) / Math.max(1, a.length - 1)), 0.44, -d / 2 + 0.16, std(cc, 0.95), 0.08); k.rotation.x = -0.28; });
    };
    T.bonheurDuJour = (g, e) => {
      const w = (e.w || 110) / 100, d = (e.d || 50) / 100, bois = std(e.c || "#5b3b24", 0.5);
      boite(g, w, 0.04, d, 0, 0.74, 0, bois); boite(g, w - 0.06, 0.1, d - 0.04, 0, 0.64, 0, bois);
      pieds(g, w - 0.04, d - 0.04, 0.64, bois, 0.022, 0.025, true);
      boite(g, w - 0.08, 0.6, d * 0.48, 0, 0.78, -d * 0.24, bois);
      for (let i = 0; i < 3; i++) [-1, 1].forEach((s) => { boite(g, w * 0.3, 0.14, 0.01, s * w * 0.27, 0.82 + i * 0.18, 0.01, std(teinteVar(e.c || "#5b3b24", 0.05), 0.5), false); sphere(g, 0.012, s * w * 0.27, 0.89 + i * 0.18, 0.025, MAT.laiton); });
    };
    T.cabinet = (g, e) => { // meuble marqueté, dessus de marbre, porte grillagée
      const w = e.w / 100, d = e.d / 100, h = e.h || 1.3, bois = std(e.c || "#8b4a1f", 0.35, 0, { envMapIntensity: 0.8 });
      boite(g, w, h - 0.12, d, 0, 0.12, 0, bois); pieds(g, w - 0.06, d - 0.06, 0.12, bois, 0.02, 0.03, true);
      boite(g, w + 0.03, 0.03, d + 0.03, 0, h, 0, std(e.marbre || "#c9b28a", 0.25));
      boite(g, w * 0.38, h - 0.3, 0.01, 0, 0.2, d / 2 + 0.002, std("#3e4732", 0.9), false);
      [-1, 1].forEach((s) => { boite(g, w * 0.22, h - 0.36, 0.01, s * w * 0.33, 0.23, d / 2 + 0.002, std("#a8642d", 0.4), false); sphere(g, 0.03, s * w * 0.33, 0.23 + (h - 0.36) * 0.72, d / 2 + 0.01, std("#e0a24a", 0.6)); });
    };
    T.placard = (g, e) => T.armoireGlace(g, Object.assign({ blanc: true }, e));
    T.cubes = (g, e) => { // cubes muraux avec livres (posés au mur, hauteur z)
      const c = std(e.c || "#b93a2c", 0.6), z = e.z || 1.35, n = e.n || 3, livres = new THREE.MeshStandardMaterial({ map: texLivres(), roughness: 0.9 });
      for (let i = 0; i < n; i++) {
        const x = -(e.w / 200) + (e.w / 100) * (i + 0.5) / n, y = z + ((i % 2) ? -0.18 : 0.12);
        boite(g, 0.42, 0.3, 0.02, x, y, 0.01, c); boite(g, 0.42, 0.02, 0.24, x, y, 0.12, c); boite(g, 0.42, 0.02, 0.24, x, y + 0.28, 0.12, c);
        boite(g, 0.02, 0.3, 0.24, x - 0.2, y, 0.12, c); boite(g, 0.02, 0.3, 0.24, x + 0.2, y, 0.12, c);
        boite(g, 0.3, 0.22, 0.16, x - 0.03, y + 0.02, 0.1, livres, false);
      }
    };
    T.bureau = (g, e) => {
      const w = e.w / 100, d = e.d / 100, bois = std(e.c || "#c9a77c", 0.55);
      boite(g, w, 0.03, d, 0, 0.72, 0, bois); pieds(g, w - 0.04, d - 0.04, 0.72, std(e.pieds || "#2a2a2a", 0.5, 0.5), 0.015, 0.03);
      boite(g, 0.34, 0.22, 0.02, w * 0.12, 0.75, -d * 0.2, MAT.ecran); boite(g, 0.3, 0.015, 0.2, w * 0.12, 0.75, 0.05, std("#b5b8bb", 0.3, 0.8));
      T.lampeBureau(g, { b: 0.75 });
    };
    T.chaiseBureau = (g, e) => { coussin(g, 0.48, 0.08, 0.46, 0, 0.44, 0, std(e.c || "#d8cbb4", 0.95), 0.04); coussin(g, 0.46, 0.4, 0.06, 0, 0.5, -0.21, std(e.c || "#d8cbb4", 0.95), 0.05); cyl(g, 0.03, 0.03, 0.4, 0, 0.04, 0, MAT.chrome); cyl(g, 0.26, 0.26, 0.03, 0, 0, 0, MAT.noirMat, 5); };
    // Cuisine et salle d'eau (équipements fixes : identiques dans tous les jeux)
    T.cuisineBas = (g, e) => {
      const w = e.w / 100, d = (e.d || 60) / 100, facade = std(e.facade || "#e2ae1c", 0.22, 0, { envMapIntensity: 1 }), plan = std(e.plan || "#1b1b1c", e.planMat ? 0.6 : 0.18, 0, { envMapIntensity: 1 });
      boite(g, w, 0.1, d - 0.06, 0, 0, -0.03, MAT.noirMat);
      boite(g, w, 0.78, d - 0.03, 0, 0.1, -0.015, std("#2a2a2a", 0.7));
      boite(g, w + 0.02, 0.04, d + 0.02, 0, 0.88, 0, plan);
      const mods = e.modules || ["porte"], lw = w / mods.length;
      mods.forEach((k, i) => {
        const x = -w / 2 + lw * (i + 0.5);
        if (k === "four") { boite(g, lw - 0.02, 0.58, 0.02, x, 0.12, d / 2 - 0.01, MAT.blancLaque, false); boite(g, lw - 0.1, 0.3, 0.01, x, 0.2, d / 2 + 0.005, MAT.ecran, false); poignee(g, x, 0.62, d / 2 + 0.02, MAT.chrome, true, lw * 0.7); boite(g, lw - 0.02, 0.16, 0.02, x, 0.71, d / 2 - 0.01, facade, false); }
        else if (k === "lv") { boite(g, lw - 0.02, 0.76, 0.02, x, 0.11, d / 2 - 0.01, e.lvBlanc ? MAT.blancLaque : std("#9fa3a6", 0.3, 0.8), false); }
        else if (k === "tiroirs") [0, 1, 2].forEach((j) => { boite(g, lw - 0.02, 0.24, 0.02, x, 0.12 + j * 0.25, d / 2 - 0.01, facade, false); poignee(g, x, 0.31 + j * 0.25, d / 2 + 0.02, MAT.chrome, true, 0.12); });
        else { boite(g, lw - 0.02, 0.74, 0.02, x, 0.12, d / 2 - 0.01, facade, false); poignee(g, x + lw * 0.3, 0.75, d / 2 + 0.02, MAT.chrome, false, 0.1); }
        if (k === "plaque" || k === "four") boite(g, lw * 0.85, 0.006, d * 0.8, x, 0.92, 0, MAT.ecran, false);
        if (k === "evier") { boite(g, lw * 0.7, 0.01, d * 0.6, x, 0.917, 0, std("#2b2b2b", 0.4, 0.6), false); const rob = cyl(g, 0.012, 0.012, 0.28, x, 0.92, -d / 2 + 0.08, MAT.chrome, 8); const bec = boite(g, 0.02, 0.02, 0.18, x, 1.18, -d / 2 + 0.17, MAT.chrome); rob.castShadow = bec.castShadow = false; }
      });
    };
    T.cuisineHaut = (g, e) => {
      const w = e.w / 100, d = (e.d || 35) / 100, z = e.z || 1.45, h = e.h || 0.7, facade = std(e.facade || "#e2ae1c", 0.22, 0, { envMapIntensity: 1 });
      boite(g, w, h, d, 0, z, d / 2, std("#ece8df", 0.7));
      const n = e.portes || Math.max(1, Math.round(w / 0.5));
      for (let i = 0; i < n; i++) { const vitre = e.vitree && i === n - 1; boite(g, w / n - 0.01, h - 0.02, 0.02, -w / 2 + (w / n) * (i + 0.5), z + 0.01, d + 0.01, vitre ? std("#c9cdd0", 0.3, 0.5) : (e.noirs && i % 2 ? std("#141414", 0.15) : facade), false); }
    };
    T.hotte = (g, e) => {
      const z = e.z || 1.55, ix = std("#b9bcbf", 0.32, 0.9);
      const cloche = new THREE.Mesh(new THREE.CylinderGeometry(0.12, 0.42, 0.22, 4, 1), ix); cloche.rotation.y = Math.PI / 4; cloche.scale.z = 0.8; cloche.position.set(0, z + 0.11, 0.3); g.add(cloche);
      boite(g, 0.24, HM - z - 0.22, 0.24, 0, z + 0.22, 0.14, ix);
    };
    T.frigo = (g, e) => {
      const w = (e.w || 70) / 100, d = (e.d || 70) / 100, h = e.h || 1.86, c = std(e.c || "#141516", 0.25, 0.3, { envMapIntensity: 1 });
      boite(g, w, h, d, 0, 0, 0, c); boite(g, w, 0.008, 0.02, 0, h * 0.62, d / 2, MAT.noirMat, false);
      boite(g, 0.03, 0.4, 0.04, -w / 2 + 0.06, h * 0.68, d / 2 + 0.02, MAT.chrome); boite(g, 0.03, 0.35, 0.04, -w / 2 + 0.06, h * 0.25, d / 2 + 0.02, MAT.chrome);
      if (e.magnets !== false) for (let i = 0; i < 12; i++) boite(g, 0.06, 0.05, 0.006, -0.1 + (i % 4) * 0.08, 1.2 + Math.floor(i / 4) * 0.08, d / 2 + 0.003, std(["#d9534f", "#f0ad4e", "#5bc0de", "#5cb85c"][i % 4], 0.6), false);
    };
    T.colonne = (g, e) => { const w = e.w / 100, d = e.d / 100, h = e.h || 2.1; boite(g, w, h, d, 0, 0, 0, std(e.facade || "#e2ae1c", 0.22)); boite(g, w - 0.02, 0.006, 0.01, 0, h * 0.45, d / 2 + 0.003, MAT.noirMat, false); };
    T.douche = (g, e) => {
      const w = e.w / 100, d = e.d / 100;
      boite(g, w, 0.03, d, 0, 0, 0, std("#e3dccf", 0.7));
      const v = boite(g, 0.008, 1.95, d * 0.85, w / 2, 0.03, -d * 0.075, MAT.verre, false); v.receiveShadow = false;
      boite(g, 0.02, 1.95, 0.02, w / 2, 0.03, -d / 2, MAT.chrome);
      cyl(g, 0.012, 0.012, 1.1, -w / 2 + 0.12, 0.95, -d / 2 + 0.06, MAT.chrome, 8);
      boite(g, 0.012, 0.012, 0.32, -w / 2 + 0.12, 2.04, -d / 2 + 0.2, MAT.chrome);
      cyl(g, 0.12, 0.12, 0.012, -w / 2 + 0.12, 2.02, -d / 2 + 0.36, MAT.chrome, 28);
      boite(g, 0.24, 0.05, 0.08, -w / 2 + 0.12, 1.05, -d / 2 + 0.05, MAT.chrome);
      boite(g, 0.32, 0.03, 0.12, w / 2 - 0.25, 1.15, -d / 2 + 0.07, MAT.chrome);
      coussin(g, 0.36, 0.04, 0.32, -w / 2 + 0.22, 0.48, 0.05, std("#9c9fa2", 0.4, 0.7), 0.02);
    };
    T.vasque = (g, e) => {
      const w = e.w / 100, d = e.d / 100, meuble = std(e.c || "#d6d0c4", 0.7);
      boite(g, w, 0.72, d, 0, 0.1, 0, meuble);
      for (let i = 0; i < 9; i++) boite(g, w - 0.08, 0.012, 0.01, 0, 0.18 + i * 0.07, d / 2 + 0.003, std("#bdb6a8", 0.7), false);
      boite(g, w + 0.02, 0.03, d + 0.02, 0, 0.82, 0, std("#ddd6c8", 0.5));
      const bol = new THREE.Mesh(new THREE.CylinderGeometry(0.21, 0.16, 0.14, 32), MAT.ceramique); bol.position.set(0.04, 0.92, 0.02); bol.castShadow = true; g.add(bol);
      cyl(g, 0.014, 0.014, 0.3, 0.3, 0.85, -d / 2 + 0.06, MAT.chrome, 8); boite(g, 0.02, 0.02, 0.17, 0.3, 1.14, -d / 2 + 0.14, MAT.chrome);
      boite(g, 0.75, 0.03, 0.12, 0, 1.12, -d / 2 + 0.06, std("#d29a4e", 0.6));
    };
    // Entrée
    T.consoleLouisXV = (g, e) => {
      const w = (e.w || 70) / 100, d = (e.d || 45) / 100, bois = std(e.c || "#9a5c2a", 0.5);
      coussin(g, w, 0.035, d, 0, 0.73, 0, bois, 0.04); boite(g, w - 0.06, 0.1, d - 0.05, 0, 0.62, 0, bois);
      [[-1, -1], [1, -1], [-1, 1], [1, 1]].forEach(([i, j]) => { const p = cyl(g, 0.02, 0.012, 0.64, i * (w / 2 - 0.04), 0, j * (d / 2 - 0.04), bois, 8); p.rotation.z = -i * 0.06; p.rotation.x = j * 0.06; });
      cyl(g, 0.07, 0.05, 0.1, 0.1, 0.765, 0, std("#ece6db", 0.4));
    };
    // Murs : tableaux, miroirs, appliques, radiateurs, carrelages, peinture (posés contre un mur, face vers +z)
    T.tableau = (g, e) => {
      const w = (e.w || 60) / 100, h = (e.h || 80) / 100, z = e.z || 1.45;
      boite(g, w + 0.06, h + 0.06, 0.03, 0, z - h / 2 - 0.03, 0.015, std(e.cadre || "#2a2622", 0.5, e.cadre === "or" ? 0.8 : 0), false);
      const toileM = new THREE.Mesh(new THREE.PlaneGeometry(w, h), new THREE.MeshStandardMaterial({ map: texTableau(e.motif || "abstrait"), roughness: 0.85 }));
      toileM.position.set(0, z, 0.032); g.add(toileM);
    };
    T.miroir = (g, e) => {
      const w = (e.w || 90) / 100, h = (e.h || 70) / 100, z = e.z || 1.45;
      if (e.rond) { const c = new THREE.Mesh(new THREE.CylinderGeometry(w / 2, w / 2, 0.02, 48), std("#c9a14a", 0.35, 0.9)); c.rotation.x = Math.PI / 2; c.position.set(0, z, 0.01); g.add(c); const m = new THREE.Mesh(new THREE.CircleGeometry(w / 2 - 0.02, 48), MAT.miroir); m.position.set(0, z, 0.022); g.add(m); return; }
      boite(g, w + 0.08, h + 0.08, 0.03, 0, z - h / 2 - 0.04, 0.015, std(e.cadre || "#d9cfba", 0.5), false);
      const m = new THREE.Mesh(new THREE.PlaneGeometry(w, h), MAT.miroir); m.position.set(0, z, 0.032); g.add(m);
    };
    T.applique = (g, e) => {
      const z = e.z || 1.65;
      boite(g, 0.05, 0.12, 0.02, 0, z - 0.1, 0.01, MAT.laiton, false);
      [-1, 1].forEach((s) => { if (e.simple && s > 0) return; cyl(g, 0.01, 0.01, 0.12, s * (e.simple ? 0 : 0.09), z - 0.04, 0.08, MAT.laiton, 6); cyl(g, 0.045, 0.06, 0.1, s * (e.simple ? 0 : 0.09), z + 0.06, 0.08, MAT.abat, 18); });
    };
    T.radiateur = (g, e) => { const w = (e.w || 70) / 100, h = e.h || 0.55, z = e.z == null ? 0.15 : e.z; boite(g, w, h, 0.07, 0, z, 0.04, MAT.blanc); for (let i = 0; i < 6; i++) boite(g, w - 0.04, 0.008, 0.005, 0, z + 0.06 + i * (h - 0.1) / 5, 0.077, std("#e5e2dc", 0.6), false); };
    T.vitrail = (g, e) => { // figure en vitrail (lamelles colorées dans un cadre de fer)
      const w = (e.w || 34) / 100, h = (e.h || 95) / 100, z = e.z || 1.45;
      boite(g, w, h, 0.01, 0, z - h / 2, 0.02, new THREE.MeshStandardMaterial({ map: texTableau("vitrail"), roughness: 0.6, transparent: true, opacity: 0.4 }), false);
      const r = alea(Math.round(w * 100 + h * 10)), cols = ["#d9473b", "#e7b730", "#2f6fb5", "#3e9b5f", "#8a4fa0", "#e98a2c"];
      for (let i = 0; i < 26; i++) boite(g, 0.05 + r() * 0.06, 0.05 + r() * 0.06, 0.012, (r() - 0.5) * w * 0.55, z - h * 0.42 + i * (h * 0.85 / 26), 0.03, std(cols[i % cols.length], 0.35), false);
    };
    T.carrelage = (g, e) => { // panneau de carrelage contre un mur (crédence, douche)
      const w = e.w / 100, z = e.z || 0.9, h = Math.min(e.h || 0.6, COUPE - z);
      if (h <= 0.02) return;
      const tex = e.motif === "metro" ? texMetro(e.c || "#1d1e22") : e.motif === "pierre" ? texLames(e.c || "#7c7d80") : texLames(e.c || "#9a8068");
      tex.repeat.set(Math.max(1, w / (e.motif === "metro" ? 0.6 : 0.8)), Math.max(1, h / (e.motif === "metro" ? 0.3 : 0.8)));
      const m = new THREE.Mesh(new THREE.PlaneGeometry(w, h), new THREE.MeshStandardMaterial({ map: tex, roughness: e.motif === "metro" ? 0.25 : 0.55, envMapIntensity: 0.8 }));
      m.position.set(0, z + h / 2, 0.004); m.receiveShadow = true; g.add(m);
    };
    T.peinture = (g, e) => { // un pan de mur repeint (largeur w, toute la hauteur)
      const m = new THREE.Mesh(new THREE.PlaneGeometry(e.w / 100, COUPE - 0.004), std(e.c || "#b4392a", 0.92));
      m.position.set(0, COUPE / 2, 0.003); m.receiveShadow = true; g.add(m);
    };
    T.plinthe = (g, e) => boite(g, e.w / 100, 0.08, 0.012, 0, 0, 0.006, MAT.blanc, false);

    const MURAUX = new Set(["tableau", "miroir", "applique", "radiateur", "vitrail", "carrelage", "peinture", "plinthe", "cubes", "cuisineHaut", "hotte"]);
    const SANS_OMBRE = new Set(["tapis", "voilages", "suspension", "statue", "lampadaire", "plante", "chien", "tabouret"]);

    // ------------------------------------------------------------ sols communs (parquets, galets…)
    const sols = new THREE.Group();
    (A.sols || []).forEach((s) => {
      const [x, y, w, d] = s.zone;
      let tex;
      if (s.type === "galets") { tex = texGalets(s.teinte || "#cdbfa8"); tex.repeat.set(w / 60, d / 60); }
      else { tex = texParquet(s.teinte || "#a8835a", s.graine || Math.round(x + y)); const echelle = (s.lame || 120) / 100 * 2.6; tex.repeat.set(w / 100 / echelle, d / 100 / (echelle * 0.62)); if (s.sens === "y") tex.rotation = Math.PI / 2; }
      const m = new THREE.Mesh(new THREE.PlaneGeometry(w * S, d * S), new THREE.MeshStandardMaterial({ map: tex, roughness: s.type === "galets" ? 0.75 : 0.5, envMapIntensity: 0.35 }));
      m.rotation.x = -Math.PI / 2;
      const [px, pz] = P(x + w / 2, y + d / 2);
      m.position.set(px, (s.h || 0) + 0.003, pz); m.receiveShadow = true;
      sols.add(m);
    });
    meubles.add(sols); // aplati avec les meubles en vue plan (l'estrade a son propre parquet)

    // ------------------------------------------------------------ les jeux de meubles
    function construire(elements) {
      const pose = new THREE.Group(), mur = new THREE.Group(), ombres = new THREE.Group();
      (elements || []).forEach((e) => {
        const f = T[e.t];
        if (!f) return;
        if (MURAUX.has(e.t) && !["carrelage", "peinture", "plinthe"].includes(e.t)) {
          const z = e.z == null ? (e.t === "radiateur" ? 0.15 : 1.45) : e.z;
          const haut = e.t === "radiateur" ? z + (e.h || 0.55) : e.t === "cuisineHaut" || e.t === "hotte" || e.t === "cubes" ? COUPE + 1 : z + (e.t === "applique" ? 0.12 : ((e.h || (e.t === "miroir" && e.rond ? e.w : 70)) / 200));
          if (haut > COUPE + 0.01) return;
        }
        const g = new THREE.Group();
        try { f(g, e); } catch (err) { return; }
        const [px, pz] = P(e.x, e.y);
        g.position.set(px, e.b || 0, pz);
        g.rotation.y = deg(e.r);
        if (e.t === "voilages") g.traverse((m) => { if (m.isMesh) m.castShadow = false; });
        (MURAUX.has(e.t) ? mur : pose).add(g);
        // ombre de contact sous les meubles posés au sol
        if (!MURAUX.has(e.t) && !SANS_OMBRE.has(e.t) && e.w && e.d && !e.sansOmbre) {
          const o = new THREE.Mesh(new THREE.PlaneGeometry((e.w + 28) * S, (e.d + 28) * S), ombreMat);
          o.rotation.x = -Math.PI / 2; o.rotation.z = -deg(e.r);
          o.position.set(px, (e.b || 0) + 0.007, pz); o.renderOrder = 1;
          ombres.add(o);
        }
      });
      meubles.add(pose); deco.add(mur); meubles.add(ombres);
      return { pose, mur, ombres };
    }
    // Équipements fixes (cuisine, salle d'eau, placards) : affichés quel que soit le jeu choisi.
    if (A.communs) construire(A.communs);
    const jeux = {};
    Object.keys(A.jeux || {}).forEach((nom) => {
      const j = construire(A.jeux[nom].elements);
      jeux[nom] = Object.assign(j, { nom: A.jeux[nom].nom || nom, virtuel: !!A.jeux[nom].virtuel, mention: A.jeux[nom].mention || "" });
      [j.pose, j.mur, j.ombres].forEach((x) => (x.visible = false));
    });
    let courant = null;
    function choisir(nom) {
      Object.keys(jeux).forEach((k) => { const v = k === nom; jeux[k].pose.visible = jeux[k].mur.visible = jeux[k].ombres.visible = v; });
      courant = jeux[nom] ? nom : null;
      return courant;
    }
    const noms = Object.keys(jeux);
    choisir(A.defaut && jeux[A.defaut] ? A.defaut : noms[0]);
    return { jeux, choisir, noms, courant: () => courant };
  }

  window.KSMeubles = { habiller };
})();
